Vue.component("piechart", {
  props: {
    data: {}
  },
  data() {
    return {
      chartid: "piechart_" + makeID(),
      width: 450,
      height: 450,
      margin: 40,
      svg: false,
      g: false,
      arc: false,
      colors: [
        "#0055A2",
        "rgba(0, 85, 162, .2)",
        "#f5efe0",
        "#6eff42",
        "#429aff",
        "#ff5b42",
        "#7442ff",
        "#ffba42",
        "#ff426e",
        "#e67a6a"
      ],
      color: false,
      pie: false,
      chartDrawn: false
    };
  },
  computed: {
    radius() {
      return Math.min(this.width, this.height) / 2 - this.margin;
    },
    dataArrayOld() {
      if (!this.data) {
        return false;
      }
      return Object.values(this.data);
    },
    dataArray() {
      if (!this.data) {
        return false;
      }
      let a = [];
      for (const d in this.data) {
        let o = {
          label: d,
          value: this.data[d]
        };
        a.push(o);
      }
      return a;
    }
  },
  watch: {
    // * Animation is janky, so currently only drawing chart once
    data(val) {
      if (val && !this.chartDrawn) {
        this.drawChart();
      }
    }
  },
  methods: {
    drawChart() {
      let $this = this;

      let data = $this.dataArray;
      var tau = 2 * Math.PI;
      if (!$this.chartDrawn) {
        $this.svg = d3
          .select("#" + $this.chartid + " svg")
          .attr("width", $this.width)
          .attr("height", $this.height);

        $this.g = $this.svg
          .append("g")
          .attr("transform", "translate(" + $this.width / 2 + "," + $this.height / 2 + ")");

        $this.color = d3.scaleOrdinal($this.colors);

        $this.pie = d3.pie();

        $this.pie
          .value(function (d) {
            return d.value;
          })
          .sort(null)(data);
        $this.arc = d3.arc().innerRadius(0).outerRadius($this.radius);

        $this.arcs = $this.g
          .selectAll("path")
          .data($this.pie(data), $this.joinKey)
          .enter()
          .append("path")
          .attr("d", $this.arc)
          .attr("fill", function (d, i) {
            return $this.color($this.joinKey(d));
          })
          .attr("transform", "translate(0, 0)");
      } else {
        $this.pie = d3
          .pie()
          .value(function (d) {
            return d.value;
          })
          .sort(null)(data);

        $this.arcs = $this.g.selectAll("path").data($this.pie, $this.joinKey);

        $this.arc = d3.arc().innerRadius(0).outerRadius($this.radius);

        $this.arcs.transition().duration(500).attr("d", $this.arc);
        /*
                $this.pie
                    .sort( null )
                    .value(function (d) {
                        console.log(d);
                        return d.value;
                      });
                
                    

                $this.pie
                    .value(function(d) { return d[value]; }); // change the value function
                console.log($this.arcs)
                $this.arcs
                    .selectAll("path")
                    .data($this.pie, $this.joinKey); // compute the new angles
                $this.arcs.transition().duration(750).attrTween("d", function (d) {
                    var interpolate = d3.interpolate(this._current, d);
                    var _this = this;
                    return function(t) {
                        _this._current = interpolate(t);
                        return $this.arc(_this._current);
                        };
                    });
                /*
                let slice = $this.arcs                    
                    .data($this.pie(data), $this.joinKey)
                
                slice
                    .transition()
                    .attrTween("d", function(d) {
                        var interpolate = d3.interpolate(this._current, d);
                        var _this = this;
                        return function(t) {
                            _this._current = interpolate(t);
                            return $this.arc(_this._current);
                          };
                      });
                /* NOT WORKING YET
                // http://bl.ocks.org/mbostock/5100636
                // 
                console.log(data);

                $this.arcs
                    .data($this.pie(data))

                $this.arcs.transition().selectAll("path")
                    
                    .attrTween("d", $this.arcTween)
                */
        /*
                    .data($this.pie(data))
                    .enter()
                    .append("g")
                    .attr("class", "arc")
                    */
      }

      $this.chartDrawn = true;
    },
    arcTween(a) {
      let $this = this;
      var i = d3.interpolate(this._current, a);
      this._current = i(0);
      return function (t) {
        return $this.arc(i(t));
      };
    },
    joinKey(d) {
      return d.data.label;
    }
  }
});
